/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <CallToAction {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section } from "@bw/bits"
import { CallToAction as CallToActionModule } from "@bw/modules"
import { graphql } from "gatsby"

const CallToAction = ({
  suptitle,
  title,
  subtitle,
  linkText,
  linkType,
  button,
  buttonPosition,
  isExternal,
  entry,
  url,
  anchor,
}) => {
  return (
    <Section {...{ button, buttonPosition: buttonPosition?.value, anchor }}>
      <CallToActionModule
        suptitle={suptitle}
        title={title}
        subtitle={subtitle}
        buttonLabel={linkText}
        external={isExternal}
        href={linkType?.value === "url" ? url : undefined}
        to={linkType?.value === "entry" && entry ? entry.url : undefined}
      />
    </Section>
  )
}

export const query = graphql`
  fragment CallToActionModuleFragment on CallToActionModule {
    isExternal
    linkText
    linkType {
      value
    }
    url
    entry {
      url
    }
  }
`

export { CallToAction }
